import { PageHeader } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const PageHeaderStyled = styled(PageHeader)`
  padding-bottom: 2rem;
`;
